<template>
    <div class="flex" style="justify-content: space-around;">
        <template v-if="cusList.length <=2">
            <div class="cursor" v-for="item in cusList" @click.stop="handle(item)" :key="item">
                {{ lab[item] }}</div>
        </template>
        <template v-else>
            <div :class="cusList[0]" @click.stop="handle(cusList[0])"></div>
            <div class="img-edit more"></div>
        </template>
    </div>
</template>

<script>
export default {
  name: "curd",
  props: {
    list: {
      type: Array,
      default: () => []
    },
    row: {
      type: Object,
      default: () => { }
    },
    idx: {
      type: Number,
      default: 0
    }
  },
  watch: {
    list: {
      handler: function (val) {
        //  = [...val];
        this.cusList = this.sort.filter(item => {
          return val.indexOf(item) > -1;
        });
      },
      immediate: true,
      deep: true,
    }
  },
  data() {
    return {
      cusList: [],
      sort: ["view", "update", "back", "confirm", "dzbd", "delete"],
      lab: {
        "view": "查看",
        "update": "更新",
        "back": "撤回",
        "confirm": "审核",
        "dzbd": "电子保单",
        "delete": "删除"
      }
    }
  },
  methods: {
    handle(type) {
      this.$emit("handle", {
        type,
        row: this.row,
        idx: this.idx
      })
    }
  }

}
</script>
<style lang="scss" scoped>
.img-edit {
  width: 18px;
  height: 14px;
  display: inline-block;
  background-size: 100% 100%;
  cursor: pointer;

  &.view {
    background-image: url('./img/view.png');
  }
  &.back {
    background-image: url('./img/back.png');
  }
  &.more {
    background-image: url('./img/more.png');
  }
  &.confirm {
    background-image: url('./img/confirm.png');
  }
  &.delete {
    background-image: url('./img/delete.png');
  }
  &.dzbd {
    background-image: url('./img/dzbd.png');
  }
  &.update {
    background-image: url('./img/update.png');
  }
}
</style>
